import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { Chevron } from '../../components/UiIcons';

const FieldSet = ({ open: openDefault, title, children }) => {
  const [open, setOpen] = useState(openDefault);

  return (
    <fieldset className={clsx('ss_fieldset', { 'ss_fieldset--open': open })}>
      <button type="button" className="ss_fieldset__title" onClick={() => setOpen(!open)}>
        {title}
        <span className="ss_fieldset__title_indicator">
          <Chevron rotate={-90} width={15} height={15} />
        </span>
      </button>
      <div className="ss_fieldset__contents_wrapper">
        <div className="ss_fieldset__contents">
          {children}
        </div>
      </div>
    </fieldset>
  );
};

FieldSet.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

FieldSet.defaultProps = {
  open: false,
};

export { FieldSet };
